/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useParams, useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom'

import { getPurchaseInfoRequestAction, postPurchaseBuyRequestAction, resetPurchasePropsAction } from '../../../../../service/actions/purchaseActions'
import { useSelector } from 'react-redux'
import { commonResetPropsAction, getPurchaseInfoAction } from '../../../../../service/actions/commonActions'
import { gtmConversionsPusher, gtmDataLayerPush } from '../../../../../components/helper'
import { ExclamationSVG } from '../../../../../components/IconSvg'
import { IRootState } from '../../../../../service/store'

let timeoutId: ReturnType<typeof setTimeout> | undefined;

const Activate = ({ isExternalActivation = false }: { isExternalActivation: boolean }) => {
  const params = useParams()
  const location = useLocation()
  const dispatch = useDispatch()
  const postPurchaseBuyResult: any | null | undefined = useSelector((state: IRootState) => state.purchaseReducer.postPurchaseBuySuccess)
  const getPurchaseInfoResult: any | null | undefined = useSelector((state: IRootState) => state.purchaseReducer.getPurchaseInfoResult)
  const postPurchaseBuyPending: any | null | undefined = useSelector((state: IRootState) => state.purchaseReducer.postPurchaseBuyPending)
  const getPurchaseInfoPending: any | null | undefined = useSelector((state: IRootState) => state.purchaseReducer.getPurchaseInfoPending)
  const postPurchaseBuyError: any | null | undefined = useSelector((state: IRootState) => state.purchaseReducer.postPurchaseBuyError)


  const purchaseInfoGTM = useSelector((state: any) => state.commonReducer.purchaseInfo)
  const getPurchaseInfoGTMPending = useSelector((state: IRootState) => state.purchaseReducer.getPurchaseInfoPending)
  const navigate = useNavigate();




  useEffect(() => {

    var queryString = encodeURIComponent(window.location.href.substring(window.location.href.indexOf('?') + 1));
    dispatch(postPurchaseBuyRequestAction({
      invoiceId: params.invoiceId,
      queryString: queryString,
      FactorIssueType: 1,
    }))
    return (() => {
      dispatch(resetPurchasePropsAction())
      if (timeoutId !== null) {
        clearTimeout(timeoutId);

      }
    })
  }, [])

  useEffect(() => {

    if (purchaseInfoGTM) {

      gtmDataLayerPush(purchaseInfoGTM, isExternalActivation ? 'purchase' : params.purchaseType, location?.state?.userInfo?.Email)

      dispatch(commonResetPropsAction())
      if (params['*']?.indexOf('purchaseLine') && params['*']?.indexOf('purchaseLine') > -1) {
        window.location.href = '../#/dashboard/thankyouline';

      } else {

        dispatch(getPurchaseInfoRequestAction({ invoiceId: params.invoiceId }))

      }
    }
  }, [purchaseInfoGTM])

  const handleSuccessBuy = () => {

    dispatch(getPurchaseInfoAction(params.invoiceId))

  }

  useEffect(() => {



    if (getPurchaseInfoResult && !isExternalActivation) {

      handleGoToPortal()
    }
    if (getPurchaseInfoResult && isExternalActivation) {
      timeoutId = setTimeout(() => {
        handleGoToPortal()

      }, 20000)
    }



  }, [getPurchaseInfoResult])


  const handleGoToPortal = () => {
    if (getPurchaseInfoResult) {
      if (getPurchaseInfoResult.IsReturning) {
        dispatch(resetPurchasePropsAction())

        switch (getPurchaseInfoResult.PurchaseType) {
          case 1:
            {
              //Ivr
              gtmConversionsPusher('thankyougooya')
              window.location.href = '../#/dashboard/thankyougooya/IsReturning';
              break;
            }

          case 3:
            {
              //Fax
              gtmConversionsPusher('thankyoufax')
              window.location.href = '../#/dashboard/thankyoufax/IsReturning';
              break;
            }

          case 4:
            {
              //Secretary
              gtmConversionsPusher('thankyoumonshi')
              window.location.href = '../#/dashboard/thankyoumonshi/IsReturning';
              break;
            }

          default:
            {
              window.location.href = '../#/dashboard';
              break;
            }
        };
      } else if (getPurchaseInfoResult.PurchaseStatus === 1) {
        //free  
        switch (getPurchaseInfoResult.PurchaseType) {
          case 1:
            {
              //Ivr
              gtmConversionsPusher('thankyougooyafree')

              window.location.href = '../#/dashboard/thankyougooyafree';
              break;
            }

          case 4:
            {
              //Secretary
              gtmConversionsPusher('thankyoumonshifree')

              window.location.href = '../#/dashboard/thankyoumonshifree';
              break;
            }

          default:
            {
              window.location.href = '../#/dashboard';
              break;
            }
        };
      }
      else if (getPurchaseInfoResult.PurchaseType === 5) {
        //charge 
        gtmConversionsPusher('thankyoucharge')
        window.location.href = '../#/dashboard/thankyoucharge';

      }
      else if (getPurchaseInfoResult.PurchaseType === 2) {
        // line
        gtmConversionsPusher('thankyouline')
        window.location.href = '../#/dashboard/thankyouline';
      }
      else if (getPurchaseInfoResult.PurchaseStatus === 3) {
        //extend
        switch (getPurchaseInfoResult.PurchaseType) {
          case 1:
            {
              //Ivr
              gtmConversionsPusher('thankyougooya')
              window.location.href = '../#/dashboard/thankyougooya/Extend';
              break;
            }

          case 3:
            {
              //Fax
              gtmConversionsPusher('thankyoufax')
              window.location.href = '../#/dashboard/thankyoufax/Extend';
              break;
            }

          case 4:
            {
              //Secretary
              gtmConversionsPusher('thankyoumonshi')
              window.location.href = '../#/dashboard/thankyoumonshi/Extend';
              break;
            }

          default:
            {
              window.location.href = '../#/dashboard';
              break;
            }
        };
      }
      else if (getPurchaseInfoResult.PurchaseStatus === 2) {
        //New
        switch (getPurchaseInfoResult.PurchaseType) {
          case 1:
            {
              //Ivr
              gtmConversionsPusher('thankyougooya')

              window.location.href = '../#/dashboard/thankyougooya/New';
              break;
            }

          case 3:
            {
              //Fax
              gtmConversionsPusher('thankyoufax')

              window.location.href = '../#/dashboard/thankyoufax/New';
              break;
            }

          case 4:
            {
              //Secretary
              gtmConversionsPusher('thankyoumonshi')

              window.location.href = '../#/dashboard/thankyoumonshi/New';
              break;
            }


          default:
            {
              window.location.href = '../#/dashboard';
              break;
            }

        };
      }
      else if (getPurchaseInfoResult.PurchaseStatus === 4) {
        //Upgrade
        switch (getPurchaseInfoResult.PurchaseType) {
          case 1:
            {
              //Ivr
              gtmConversionsPusher('thankyougooya')
              window.location.href = '../#/dashboard/thankyougooya/Upgrade';
              break;
            }

          case 3:
            {
              //Fax
              gtmConversionsPusher('thankyoufax')
              window.location.href = '../#/dashboard/thankyoufax/Upgrade';
              break;
            }

          case 4:
            {
              //Secretary
              gtmConversionsPusher('thankyoumonshi')

              window.location.href = '../#/dashboard/thankyoumonshi/Upgrade';
              break;
            }

          default:
            {

              window.location.href = '../#/dashboard';
              break;
            }
        };
      } else if (getPurchaseInfoResult.PurchaseStatus === 5) {
        window.location.href = '../#/dashboard';
      }
    }
  }

  useEffect(() => {
    if (postPurchaseBuyResult) {

      dispatch(resetPurchasePropsAction())

      handleSuccessBuy()


    }
  }, [postPurchaseBuyResult])


  if (postPurchaseBuyPending || getPurchaseInfoPending || getPurchaseInfoGTMPending) {
    return <div className='content-container'><div className='invoice-loading' ></div></div>
  }

  if (postPurchaseBuyError) {

    if (postPurchaseBuyError?.data?.ExceptionType?.endsWith('.PaymentFailure')) {
      return <div className='active-package-error'>
        <span>
          <ExclamationSVG width={20} height={20} />
        </span>

        باعرض پوزش از خطایی که در فرآیند پرداخت رخ داده است. لطفا دوباره نسبت به خرید اقدام نمایید.
      </div>
    } else {
      return <div className='active-package-error'>
        <span>
          <ExclamationSVG width={20} height={20} />
        </span>

        مشکلی در ثبت درخواست شما به وجود آمده است. برای تکمیل فرآیند فروش، لطفا با بخش پشتیبانی تماس بگیرید.
        {isExternalActivation && <div className='d-flex justify-content-end mx-2'>
          <button type="button" className="btn  btn-success" style={{ display: "flex", alignItems: "center" }} onClick={() => navigate("/dashboard")}>
            ورود به پرتال
            <i className="fa fa-angle-left" style={{ marginRight: "10px" }}></i>
          </button>
        </div>}
      </div>
    }

  }

  if (isExternalActivation && getPurchaseInfoResult) {
    return (
      <div className="activation-alert-success"
      >
        <h3 className="block">فعالسازی</h3>

        <div>
          <div >
            <div className='icon-container' >
              <i className="fa fa-check-circle-o"
              >
              </i>
            </div>
            <div className='description-context'  >
              <span style={{ display: "inline-block" }} >
                با تشکر از انتخاب شما!
              </span>
              <br />
              <span >
                درخواست شما با موفقیت ثبت گردید. ایمیل فعالسازی تا چند دقیقه دیگر برای شما ارسال خواهد شد.
                <br />
                شماره‌(ها)ی شما حداکثر ظرف 30 دقیقه فعال خواهد شد.
              </span>
              <span>
                برای تکمیل مراحل خرید، لطفا به ایمیل‌تان مراجعه نموده و نسبت به تایید ایمیل و شماره تلفن همراه خود اقدام نمایید. کارشناسان ما برای پیگیری فعالسازی بسته شما، ظرف ۲۴ ساعت کاری با شما تماس خواهند گرفت.
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-end" style={{ marginTop: "50px" }}>
            <button type="button" className="btn  btn-success" style={{ display: "flex", alignItems: "center" }} onClick={handleGoToPortal}>
              ورود به پرتال
              <i className="fa fa-angle-left" style={{ marginRight: "10px" }}></i>
            </button>
          </div>
        </div>

      </div>
    )

  }
  return <div>


  </div>
}

export default Activate
